import { dateTime } from "@/lib/pricing";
import { ROLE_LABELS } from "@/lib/team";

const ACTIONS = {
  "team.invitation_sent": "Invitation sent", "team.invitation_resent": "Invitation resent",
  "team.invitation_cancelled": "Invitation cancelled", "team.account_activated": "Account set up",
  "team.role_changed": "Role changed", "team.user_suspended": "Suspended",
  "team.user_reactivated": "Reactivated", "team.access_revoked": "Access revoked",
};

function change(meta = {}) {
  const parts = [];
  if (meta.previous_role && meta.new_role && meta.previous_role !== meta.new_role) parts.push(`${ROLE_LABELS[meta.previous_role]} → ${ROLE_LABELS[meta.new_role]}`);
  else if (meta.new_role && !meta.previous_role) parts.push(ROLE_LABELS[meta.new_role]);
  if (meta.previous_status && meta.new_status) parts.push(`${meta.previous_status} → ${meta.new_status}`);
  return parts.join(" · ");
}

export function MemberHistory({ rows }) {
  return (
    <section className="pf-card p-6 mt-6" data-testid="team-detail-history">
      <h3 className="font-semibold text-slate-900">Access history</h3>
      <ol className="mt-4 space-y-3">
        {rows.map((h) => (
          <li key={h.id} className="flex gap-3 text-sm" data-testid={`team-history-${h.id}`}>
            <span className="w-2 h-2 rounded-full bg-cyan-500 mt-1.5 shrink-0" />
            <div className="min-w-0">
              <div className="font-medium text-slate-900">{ACTIONS[h.action] || h.action} <span className="text-slate-500 font-normal">{change(h.meta)}</span></div>
              <div className="text-xs text-slate-500 break-all">{dateTime(h.created_at)} · by {h.actor_email || "system"}</div>
              {h.meta?.reason && <div className="text-xs text-slate-600 mt-0.5">Reason: {h.meta.reason}</div>}
            </div>
          </li>
        ))}
        {rows.length === 0 && <li className="text-sm text-slate-500">No access changes recorded yet.</li>}
      </ol>
    </section>
  );
}

export function RecentActivity({ rows }) {
  return (
    <section className="pf-card p-6 mt-6" data-testid="team-detail-activity">
      <h3 className="font-semibold text-slate-900">Recent Cyannect Admin activity</h3>
      <ul className="mt-4 divide-y divide-white/60">
        {rows.map((a, i) => (
          <li key={`${a.created_at}-${i}`} className="py-2 flex justify-between gap-3 text-sm">
            <span className="font-mono text-xs text-slate-800 break-all">{a.action}</span>
            <span className="text-xs text-slate-500 whitespace-nowrap">{dateTime(a.created_at)}</span>
          </li>
        ))}
        {rows.length === 0 && <li className="py-2 text-sm text-slate-500">No admin actions yet.</li>}
      </ul>
    </section>
  );
}
